import axios from '@/libs/api.request'
import config from '@/config'

export const getPersonlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/person/person/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationPerson = (data, meth) => {
  return axios.request({
    url: '/v1/person/person/',
    method: meth,
    data
  })
}

export const getapplicationlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/person/application/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}
